var _circle, _path, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMappin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 56,
    r: 2,
    fill: "#FF5917"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 52L21 47H27L24 52Z",
    fill: "#FF5917"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF5917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 33.1667C24 33.1667 31.5 28.1667 31.5 22.3333C31.5 20.3442 30.7098 18.4366 29.3033 17.03C27.8968 15.6235 25.9891 14.8333 24 14.8333C22.0109 14.8333 20.1032 15.6235 18.6967 17.03C17.2902 18.4366 16.5 20.3442 16.5 22.3333C16.5 28.1667 24 33.1667 24 33.1667ZM26.5 22.3333C26.5 23.7141 25.3807 24.8333 24 24.8333C22.6193 24.8333 21.5 23.7141 21.5 22.3333C21.5 20.9526 22.6193 19.8333 24 19.8333C25.3807 19.8333 26.5 20.9526 26.5 22.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.c4b5e1913c8dd49d3fdcfc8ca551093a.svg";
export { ForwardRef as ReactComponent };